
export class ApartadoModel {
    public Id: number = 0;
    public IdMenuOpcion: number;
    public Acronimo: string;
    public Nombre: string;
    public SubApartado: string;
    public Descripcion: string;
    public Observaciones: string;
}